<div class="header" [class.connected]="status === 'connected'" [class.disconnected]="status === 'disconnected'">
    <div class="inner">
        <img class="image"
            [src]="status === 'connected' ? 'assets/images/success.png' : 'assets/images/white_success.png'"
            [alt]="status === 'connected' ? 'connect' : 'disconnected'">
        <h2 class="title">{{ status === 'connected' ? ('Home.ConnectionHeader.Connected' | translate) :
            ('Home.ConnectionHeader.Disconnected' | translate) }}</h2>
    </div>
    <div (click)="toggleStatus()" class="status">
        <img class="image2"
            [src]="status === 'connected' ? 'assets/images/connection.png' : 'assets/images/disconnect.png'"
            [alt]="status === 'connected' ? 'connection' : 'disconnect'">
    </div>
</div>